export const iconFontAwesomeHumanitarianStethoscope = (
	<i className="fa-solid fa-stethoscope"></i>
);
